import React, { useEffect, useRef, useState } from "react";
import { StyledVibratingIcon } from "../../../styled/Icons";

const VibratingIcon = ({ icon, ...iconProps }) => {

    const [vibrar, setVibrar] = useState();
    const timeoutID = useRef();

    useEffect(() => {
        handleHover();
        return () => {
            clearTimeout(timeoutID.current);
        };
    }, []);

    const handleHover = () => {
        setVibrar(true);

        timeoutID.current = setTimeout(() => {
            setVibrar(false);
        }, 500);
    };


    return (
        <StyledVibratingIcon.Icon
            vibrar={vibrar}
            onMouseEnter={handleHover}
        >
            {React.cloneElement(icon, {
                ...iconProps,
            })}
        </StyledVibratingIcon.Icon>
    );
}


export default VibratingIcon;